import { Component, Input } from "@angular/core";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";

@Component({
    selector: "svg-icon",
    imports: [],
    templateUrl: "./svg-icon.component.html"
})
export class SvgIconComponent {
    @Input({ required: true }) public svgIcon!: SvgIcon;
    @Input() public small: boolean = false;

    public svgIconSvg!: string;
    
    public ngOnChanges(): void {
        this.svgIconSvg = SvgIconMap.get(this.svgIcon)!;
    }
}